import { createFileRoute } from '@tanstack/react-router';
import { cachedApprovedOrganization, membersQuery } from '@/features/organizer/api';
import { MembersPage } from '@/features/organizer/pages/MembersPage';

export const Route = createFileRoute('/_authed/org/$organizationId/members')({
  staticData: { help: 'members' },
  loader: ({ context: { queryClient }, params }) => {
    const organization = cachedApprovedOrganization(queryClient, params.organizationId);
    if (organization) void queryClient.prefetchQuery(membersQuery(organization));
  },
  component: MembersPage,
});
